import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FDTitleText } from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('StepActions', () => ({
  list: {
    margin: 0,
  },
}));

export function StepActions({ collection, label }) {
  const classes = useStyles();
  const resources = useMemo(() => collection.resources().list(), [collection]);
  if (resources.length === 0) {
    return null;
  }
  return (
    <FDTitleText
      size="sm"
      value={(
        <>
          {label}
          <ul className={classes.list}>
            {resources.map(resource => (<li key={resource?.id}>{resource.attr('title')}</li>))}
          </ul>
        </>
      )}
    />
  );
}
StepActions.defaultProps = {
};

StepActions.propTypes = {
  collection: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
};
